import { IsUUID } from 'class-validator';

export class ChatGetNameOptionsRequest {
    @IsUUID()
    public readonly chatUuid: string;

    constructor(data?: Partial<ChatGetNameOptionsRequest>) {
        this.chatUuid = data?.chatUuid;
    }
}
